import '../scss/sg1.scss'
import { main } from './main.js'


// Specific orchestrators
import { Carrousel, carrouselStyle, carrouselPlaceholder } from '../components/carrousel/carrousel.jsx'
import { Banniere, banniereStyle, bannierePlaceholder } from '../components/banniere/banniere.jsx'

/*
 * Config.events Options
 *
 *  - check             {array}         vérifie que les données du tableau sont bien présentes
 *  - component         {Component}     composant à afficher
 *  - data              {object}        données supplémentaires à passer au composant
 *  - dynamicPosition   {boolean}       si true, utilise la position dynamique
 *  - elementId         {string}        id de l'élément dans le DOM
 *  - noData            {boolean}       si true, ne vérifie pas les données
 *  - orchestrator      {function}      fonction spécifique d'orchestration
 *  - placeholderStyle  {string}        import le style du placeholder
 *  - state             {signal}        si présent, utilise le state pour afficher le composant
 *  - shadowDOM         {boolean}       si true, utilise le shadowDOM pour afficher le composant
 *  - shadowStyle       {string}        si présent, injecte le style dans le shadowDOM
 */
const config = {
    sseURL: {
        domain: {
            default: 'https://www.orange.fr',
            development: 'https://dev.orange.fr',
            exceptions: [],
        },
        path: {
            shop: 'api/events/shop/vitrine_mobile_forfait',
            boutique_confirmation_commande: 'api/events/shop/confirmation_commande'
        }
    },
    events: {
        carrousel: {
            component: Carrousel,
            shadowDOM: true,
            shadowStyle: carrouselStyle,
            placeholder: true,
            placeholderStyle: carrouselPlaceholder,
            elementId: 'carrousel',
            data: { marginBottom: '', format: '1440x310-960x1040' }
        },
        postCommande: {
            component: Banniere,
            shadowDOM: true,
            shadowStyle: banniereStyle,
            placeholder: true,
            placeholderStyle: bannierePlaceholder,
            elementId: 'postCommande',
            data: { format: '1440x310-960x1040' }
        }
    }
}

export const sg1Start = (profile, context) => {
    main(config, profile, context)
}
